module.exports = __webpack_public_path__ + "static/lemonade-2-235fe923cafab6d004e3da749e7c6b27.jpeg";